import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../../../shared/crud/form";

export const messages = defineMessages({
  ...defaultFormMessages,
  title: {
    id: "extras.editByExcel.title",
    defaultMessage: "Apply extra to: {extraId}",
  },
  description: {
    id: "extras.editByExcel.description",
    defaultMessage: "Update extra",
  },
  dropHere: {
    id: "app.imageManager.dropHere",
    defaultMessage: "Drop files here...",
  },
  row: {
    id: "extras.editByExcel.row",
    defaultMessage: "Row",
  },
  reason: {
    id: "extras.editByExcel.reason",
    defaultMessage: "Reason",
  },
  import: {
    id: "extras.editByExcel.import",
    defaultMessage: "Import",
  },
  exportToExcel: {
    id: "extras.editByExcel.exportToExcel",
    defaultMessage: "Download template",
  },
  processedSuccessfully: {
    id: "extras.editByExcel.processedSuccessfully",
    defaultMessage: "Processed successfully",
  },
  errorsFound: {
    id: "extras.editByExcel.errorsFound",
    defaultMessage: "rows with errors were found",
  },
  rawResult: {
    id: "extras.editByExcel.rawResult",
    defaultMessage: "Raw result",
  },
});
